import React from "react";
import { Routes, Route } from "react-router-dom";

import AuthProvider from "../component/AuthProvider";

const AuthProviderRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthProvider />} />
    </Routes>
  );
};

export default AuthProviderRoutes;
